import React from 'react';
import Chip from '@mui/material/Chip';

export interface TimeSpanChipProps {
  label: string;
  onDelete?: () => void;
  color?:
    | 'default'
    | 'primary'
    | 'secondary'
    | 'error'
    | 'info'
    | 'success'
    | 'warning';
}

const TimeSpanChip: React.FC<TimeSpanChipProps> = ({
  label,
  onDelete,
  color = 'primary',
}) => (
  <Chip
    label={label}
    {...(onDelete ? { onDelete } : {})}
    color={color}
    variant="outlined"
    sx={{ m: 0.5 }}
  />
);

export default TimeSpanChip;
